import { put, call, all, takeLatest } from "redux-saga/effects";

import { coworker } from "../util/routers";
import { axiosPost, axiosGet, axiosPut } from "../util/axios";
import { HTTP_SUCCESS_STATUSES } from "../constants/http_constants";

import * as actionType from "../constants/action_types";
import * as actions from "../actions/index";
import { toast } from "react-toastify";

function* getCoWorkers(action) {
  try {
    yield put(actions.RESET_STATE("coworker.update_response"));
    const url = `${coworker}`;
    const params = { ...action.payload };
    let { data, status } = yield call(axiosGet, url, { params });
    yield put(actions.GETCOWORKERS_RESPONSE({ ...data, status }));
  } catch (error) {
    yield put(actions.GETCOWORKERS_RESPONSE(error));
  }
}

function* toggleCoworker(action) {
  try {
    const url = `${coworker}/${action.payload.coworker_uid}/update`;
    const payload = { ...action.payload };

    payload._isResetPassword = false;
    payload._isUpdateCoworker = false;

    payload._isToggleMode = true;
    payload.is_deleted = false;
    payload.is_activate = !payload.is_active;
    payload.is_active = !payload.is_active;

    let { data, status } = yield call(axiosPut, url, payload);

    if (HTTP_SUCCESS_STATUSES.includes(status)) {
      toast(data.message || "Succesfully updated coworker status.", {
        type: "success",
      });
      yield put(
        actions.TOGGLECOWORKER_RESPONSE({
          coworker_uid: action.payload.coworker_uid,
          ...data,
          status,
        })
      );
    } else throw new Error(data?.message || data?.error?.message);
  } catch (error) {
    yield put(actions.STOP_LOADER);
    toast(error.message || "Error in updating coworker status.", {
      type: "error",
    });
  }
}

function* deleteCoworker(action) {
  try {
    const url = `${coworker}/${action.payload.coworker_uid}/update`;
    const payload = { ...action.payload };
    if (payload.is_active)
      throw new Error("Deactivate before deleting a coworker.");

    payload._isResetPassword = false;
    payload._isUpdateCoworker = false;

    payload._isToggleMode = true;
    payload.is_deleted = true;
    payload.is_activate = payload.is_active;

    let { data, status } = yield call(axiosPut, url, payload);

    if (HTTP_SUCCESS_STATUSES.includes(status)) {
      toast(data.message || "Succesfully deleted coworker status.", {
        type: "success",
      });
      yield put(
        actions.DELETECOWORKER_RESPONSE({
          coworker_uid: action.payload.coworker_uid,
          ...data,
          status,
        })
      );
    } else throw new Error(data?.message || data?.error?.message);
  } catch (error) {
    yield put(actions.STOP_LOADER);
    toast(error.message || "Error in deleting coworker status.", {
      type: "error",
    });
  }
}

function* resetPassword(action) {
  try {
    let user = JSON.parse(localStorage.getItem("user"));
    const url =
      action.payload.coworker_uid === user.coworker_uid
        ? `${coworker}/profile`
        : `${coworker}/${action.payload.coworker_uid}/reset_password`;
    const payload = { ...action.payload };

    payload._isUpdateCoworker = false;
    payload._isToggleMode = false;

    payload._isResetPassword = true;

    let { data, status } = yield call(axiosPut, url, payload);

    if (HTTP_SUCCESS_STATUSES.includes(status)) {
      toast(data.message || "Succesfully updated coworker password.", {
        type: "success",
      });
      yield put(
        actions.RESETCOWORKERPWD_RESPONSE({
          coworker_uid: action.payload.coworker_uid,
          ...data,
          status,
        })
      );
    } else throw new Error(data?.message || data?.error?.message);
  } catch (error) {
    yield put(actions.STOP_LOADER);
    toast(error.message || "Error in updating coworker password.", {
      type: "error",
    });
  }
}

function* createCoworker(action) {
  try {
    const url = `${coworker}`;
    if (
      action.payload.profile_pic &&
      typeof action.payload.profile_pic === "object"
    ) {
      const { data: uploadData } = yield call(
        axiosPost,
        `/upload/profile`,
        { img: action.payload.profile_pic },
        {
          headers: {
            "Content-type": "multipart/form-data",
          },
        }
      );
      action.payload.profile_pic = uploadData?.key;
    }

    const payload = { ...action.payload };

    let { data, status } = yield call(axiosPost, url, payload);

    if (HTTP_SUCCESS_STATUSES.includes(status)) {
      toast(data.message || "Succesfully created coworker.", {
        type: "success",
      });
      yield put(
        actions.CREATECOWORKER_RESPONSE({
          ...data,
          status,
        })
      );
    } else throw new Error(data?.message || data?.error?.message);
  } catch (error) {
    yield put(actions.STOP_LOADER);
    toast(error.message || "Error in creating coworker.", {
      type: "error",
    });
  }
}

function* editCoworker(action) {
  try {
    let user = JSON.parse(localStorage.getItem("user"));
    const url =
      action.payload.coworker_uid === user.coworker_uid
        ? `${coworker}/profile`
        : `${coworker}/${action.payload.coworker_uid}/update`;
    if (
      action.payload.profile_pic &&
      typeof action.payload.profile_pic === "object"
    ) {
      const { data: uploadData } = yield call(
        axiosPost,
        `/upload/profile`,
        { img: action.payload.profile_pic },
        {
          headers: {
            "Content-type": "multipart/form-data",
          },
        }
      );
      action.payload.profile_pic = uploadData?.key;
    }

    const payload = { ...action.payload };

    payload._isUpdateCoworker = true;
    payload._isToggleMode = false;

    payload._isResetPassword = false;

    let { data, status } = yield call(axiosPut, url, payload);

    if (HTTP_SUCCESS_STATUSES.includes(status)) {
      toast(data.message || "Succesfully updated coworker details.", {
        type: "success",
      });
      let user = JSON.parse(localStorage.getItem("user"));
      if (user.coworker_uid === action.payload.coworker_uid) {
        user.profile_pic = action.payload.profile_pic;
        yield put(actions.SAVE_TO_LOCAL([["user", JSON.stringify(user)]]));
      }
      yield put(
        actions.EDITCOWORKER_RESPONSE({
          ...data,
          status,
        })
      );
    } else throw new Error(data?.message || data?.error?.message);
  } catch (error) {
    yield put(actions.STOP_LOADER);
    toast(error.message || "Error in updating coworker details.", {
      type: "error",
    });
  }
}

function* getCoWorkerDetails(action) {
  try {
    yield put(actions.RESET_STATE("coworker.update_response"));
    const url = `${coworker}/${action.payload.coworker_uid}/details`;
    const params = { ...action.payload };
    let { data, status } = yield call(axiosGet, url, { params });
    yield put(actions.GETCOWORKER_RESPONSE({ ...(data?.data || {}), status }));
  } catch (error) {
    yield put(actions.GETCOWORKER_RESPONSE(error));
  }
}

function* getCoworkerCompanies(action) {
  try {
    yield put(actions.RESET_STATE("coworker.update_response"));
    const url = `${coworker}/${action.payload.coworker_uid}/companies`;
    const params = { ...action.payload.params };
    let { data, status } = yield call(axiosGet, url, { params });
    yield put(
      actions.GETCOWORKERCOMPANIES_RESPONSE({
        data: data.data,
        totalCount: data.total_records,
        status,
      })
    );
  } catch (error) {
    yield put(actions.GETCOWORKERCOMPANIES_RESPONSE(error));
  }
}

function* addCoworkerCompany(action) {
  try {
    const url = `${coworker}/companies`;
    const payload = { ...action.payload };
    let { data, status } = yield call(axiosPut, url, payload);

    if (HTTP_SUCCESS_STATUSES.includes(status)) {
      if (data?.type !== "SUCCESS") {
        throw new Error(data?.message || data?.error?.message);
      }
      toast(data.message || "Succesfully updated coworker details.", {
        type: "success",
      });
      yield put(
        actions.COWORKERCOMPANY_RESPONSE({
          ...data,
          status,
        })
      );
    } else throw new Error(data?.message || data?.error?.message);
  } catch (error) {
    yield put(actions.STOP_LOADER);
    toast(error.message || "Error in updating coworker details.", {
      type: "error",
    });
  }
}

function* reset2fa(action) {
  try {
    const url = `${coworker}/two_fa/generate/${action.payload?.coworker_uid}`;

    let { data, status } = yield call(axiosGet, url);

    if (HTTP_SUCCESS_STATUSES.includes(status)) {
      yield put(
        actions.RESET2FA_RESPONSE({
          ...data,
          status,
        })
      );
    } else throw new Error(data?.message || data?.error?.message);
  } catch (error) {
    yield put(actions.STOP_LOADER);
    toast(error.message || "Error in generating 2FA for coworker.", {
      type: "error",
    });
  }
}

function* resendOnboardingLink(action) {
  try {
    const url = `${coworker}/${action.payload?.coworker_uid}/resend-onboarding-link`;

    let { data, status } = yield call(axiosPut, url);

    if (HTTP_SUCCESS_STATUSES.includes(status)) {
      yield put(
        actions.RESENDONBOARDINGLINK_RESPONSE({
          ...data,
          status,
        })
      );
      toast(data.message || "Setup link sent successfully.", {
        type: "success",
      });
    } else throw new Error(data?.message || data?.error?.message);
  } catch (error) {
    yield put(actions.STOP_LOADER);
    toast(error.message || "Error in sending setup link to coworker.", {
      type: "error",
    });
  }
}

function* coworkerWatcherSaga() {
  yield all([
    takeLatest(actionType.GETCOWORKERS_REQ, getCoWorkers),
    takeLatest(actionType.TOGGLECOWORKER_REQ, toggleCoworker),
    takeLatest(actionType.DELETECOWORKER_REQ, deleteCoworker),
    takeLatest(actionType.RESETCOWORKERPWD_REQ, resetPassword),
    takeLatest(actionType.CREATECOWORKER_REQ, createCoworker),
    takeLatest(actionType.EDITCOWORKER_REQ, editCoworker),
    takeLatest(actionType.GETCOWORKER_REQ, getCoWorkerDetails),
    takeLatest(actionType.COWORKERCOMPANY_REQ, addCoworkerCompany),
    takeLatest(actionType.RESENDONBOARDINGLINK_REQ, resendOnboardingLink),
    takeLatest(actionType.RESET2FA_REQ, reset2fa),
    takeLatest(actionType.GETCOWORKERCOMPANIES_REQ, getCoworkerCompanies),
  ]);
}

export default coworkerWatcherSaga;
